export const defaultFontsConfig = ['roboto', 'helvetica-neue', 'arial', 'noto-sans'];